export enum PaymentMethodType {
  CARD = "card",
  SEPA_DEBIT = "sepa_debit",
}
